import { render, staticRenderFns } from "./GenelIstatistikDerdest.vue?vue&type=template&id=e9b444a2&scoped=true"
import script from "./GenelIstatistikDerdest.vue?vue&type=script&lang=ts"
export * from "./GenelIstatistikDerdest.vue?vue&type=script&lang=ts"
import style0 from "./GenelIstatistikDerdest.vue?vue&type=style&index=0&id=e9b444a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b444a2",
  null
  
)

export default component.exports